export const isDevelopmentMode = process.env.NODE_ENV === 'development';

export const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';

const ONE_TRUST_PRODUCTION_PROFILE_ID = "dda4ef64-5b84-4852-8b8d-8b2b07b4bcdf";

const ONE_TRUST_TESTING_PROFILE_ID = "dda4ef64-5b84-4852-8b8d-8b2b07b4bcdf-test";

export const ONE_TRUST_PROFILE_ID = (isDevelopmentMode || isLocalhost) ? ONE_TRUST_TESTING_PROFILE_ID : ONE_TRUST_PRODUCTION_PROFILE_ID;